export default "__VITE_ASSET__715d418e__"